<template>
    <RouterLink :to="`/admin/organizations/${organizationId}/group`"
        class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
        <img :src="detailsBlade1" width="24" height="24" alt="">
        <img :src="profileIcon">
        <p class="rlms-fw-500" id="name-text">{{ group?.name }}</p>
    </RouterLink>
    <div class="box-lr-wrapper">
        <!-- Left Section -->
        <div class="box-left rlms-flex rlms-flex-col rlms-gap-20">
            <!-- Authorized Users -->
            <div class="detail-box rlms-border rlms-br-16">
                <div class="detail-box-head rlms-border-bottom">
                    <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
                        <span class="rlms-fw-500 rlms-sm-sm">Authorized User</span>
                    </div>
                </div>
                <template v-if="authorizedUser.length">
                    <div class="rlms-table">
                        <div class="rlms-table-inner">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Permission</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="user in authorizedUser" :key="user.id">
                                        <td>
                                            <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                                <img :src="user?.profile_picture ?? profileIcon">
                                                <div class="rlms-flex rlms-flex-col">
                                                    <div class="rlms-fw-500">{{ user?.firstname }} {{
                                                        user?.lastname
                                                    }}<br />{{ user?.email }}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            {{capitalize(permissions.find(i => i.id === user.permission_id)?.name)}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>
                <div class="detail-box-body rlms-flex rlms-flex-col rlms-gap-20 rlms-text-center rlms-justify-center"
                    style="min-height: 200px" v-else>
                    <div class="rlms-avatar-group rlms-justify-center">
                        <div v-for="n in 3" :key="n" class="rlms-avatar">
                            <img :src="defaultImage" />
                        </div>
                    </div>

                    <p v-if="true">
                        Currently there are no authorized users in the group. Tap the 'Add User' button to add one.
                    </p>
                </div>
            </div>

            <!-- Learners -->
            <div class="detail-box rlms-border rlms-br-16">
                <div class="detail-box-head rlms-border-bottom">
                    <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
                        <span class="rlms-fw-500 rlms-sm-sm">Learners</span>
                    </div>
                </div>
                <div class="rlms-table" v-if="group?.learners?.length">
                    <div class="rlms-table-inner">
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="learner in group?.learners" :key="learner.id">
                                    <td>
                                        <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                            <img :src="profileIcon">
                                            <div class="rlms-flex rlms-flex-col">
                                                <div class="rlms-fw-500">{{ learner?.firstname }} {{ learner?.lastname
                                                    }}</div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="detail-box-body rlms-flex rlms-flex-col rlms-gap-30 rlms-text-center" v-else>
                    <img :src="learnerImage" class="rlms-mx-auto" style="width: 100px" />
                    <p>No Learners Available to be added to this group</p>
                </div>
            </div>
        </div>

        <!-- Right Section -->
        <div class="box-right rlms-flex rlms-flex-col rlms-gap-20">
            <div class="detail-box rlms-border rlms-br-16">
                <div class="detail-box-head rlms-border-bottom">
                    <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
                        <span class="rlms-fw-500 rlms-sm-sm">Group</span>
                    </div>
                </div>
                <div class="detail-box-body" id="general-info-content">
                    <ul class="db-ul-style-3">
                        <li>
                            <span class="rlms-fs-xs rlms-text-extra-3 rlms-fw-500">Name</span>
                            <p>{{ formatDate(group?.name) }}</p>
                        </li>
                        <li>
                            <span class="rlms-fs-xs rlms-text-extra-3 rlms-fw-500">Description</span>
                            <p>{{ group?.description || '-' }}</p>
                        </li>
                        <li>
                            <span class="rlms-fs-xs rlms-text-extra-3 rlms-fw-500">Created</span>
                            <p>{{ formatDate(group?.created_at) }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import defaultImage from "@/assets/images/no-image.png";
import learnerImage from "@/assets/images/kids-reading-book.png";
import { useRoute } from 'vue-router'
import { capitalize, onMounted, ref } from 'vue'
import axios from "@/services/axios";
import { formatDate } from '@/utils/format-helpers';
import { handleError } from "@/utils/handleError";
import { useLoaderStore } from "@/stores/loader";
import detailsBlade1 from '@/assets/images/details_blade_587e9213.svg'
import profileIcon from '@/assets/images/profile.svg'

const route = useRoute();
const loader = useLoaderStore();

const organizationId = Number(route.params.organization ?? 0);
const groupId = Number(route.params.groupId ?? 0);
const group = ref(null);
const learners = ref([]);
const permissions = ref([]);
const showModal = ref(false);
const showAddLearnerModal = ref(false);
const showAuthorizedUserModal = ref(false);
const authorizedUser = ref([]);

const selectedLearners = ref([]);

onMounted(async () => {
    await init();
});

const init = async () => {
    showModal.value = false;
    showAddLearnerModal.value = false;
    showAuthorizedUserModal.value = false;
    await fetchData();
}

const fetchData = async () => {
    try {
        loader.show();

        const { data } = await axios.get(`/admin/organizations/${organizationId}/groups/${groupId}`);
        learners.value = data.data?.learners || [];
        permissions.value = data.permissions || [];
        group.value = data.data.groups;
        authorizedUser.value = data.data.groups?.users || [];
        const learnerIds = group.value?.learners?.map(learner => learner.id) || [];
        selectedLearners.value = learnerIds;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};
</script>